import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface HeroWordsProps {
    text: string
    className?: string
}

/*
 * Renders the page's main heading (h1) using the template's hero-text word
 * structure so the page-load cascade (which targets .hero-text) reveals it
 * word by word. `no-margins` cancels the default h1 margins so it sits exactly
 * like the original markup.
 */
export const HeroWords: FC<HeroWordsProps> = ({ text, className }): ReactNode => {
    const words = text.split(' ').filter(Boolean)

    return (
        <h1 className={cn('hero-text-content no-margins', className)}>
            <div className='hero-text-word'>
                {words.map((word, i) => (
                    <div className='hero-text-letter' key={`${word}-${i}`}>
                        <div className={`hero-text _${i + 1}`}>{word}</div>
                    </div>
                ))}
            </div>
        </h1>
    )
}
